export default async function getAnonymousToken(createAnonymousToken: () => Promise<string>) {
  try {
    return await createAnonymousToken()
  } catch (e) {
    console.error('Failed to get anonymous token:', e)
    return ''
  }
}
